module.exports = __webpack_public_path__ + "img/arrow_dmain.9a28e36c.svg";